<template lang="pug">
el-table(:data="groups" cell-class-name="el-table-cell" row-class-name="el-table-row" v-loading="loading")
  .empty(slot="empty")
    img(:src="images.group_empty")
    p(v-html="nl2br($t('Cuona.Event.description07'))")
    template(v-if="edit==true")
      el-button(type="info" size="mini" @click="$emit('openDialog')") {{ $t('Cuona.Group.set_group') }}
    template(v-else)
      el-button(type="info" size="mini" @click="$emit('openCreateDialog')") {{ $t('Cuona.Group.set_group') }}
  el-table-column(width="250px" prop="name" :label="$t('Cuona.Group.name')" sortable="")
  el-table-column(prop="manager.name" :label="$t('Cuona.Group.manager')" sortable="")
  el-table-column(width="130px" prop="devices.length" :label="$t('Cuona.Group.cuona_num')" sortable="" align="center")
  template(v-if="edit==false")
    el-table-column(width="140px" prop="events.length" :label="$t('Cuona.Group.event_num')" sortable="" align="center")
  el-table-column(prop="description" :label="$t('Cuona.Group.note')")
  el-table-column(width="100px" align="center")
    template(slot-scope="props")
      router-link(:to="{name:'group', params:{id:props.row.id}}")
        i.setting.el-icon-setting
        | {{ $t('Cuona.Group.detail') }}
</template>

<script>
export default {
  data () {
    return {
      images: {
        group_empty: require('@/assets/empty_event_group.svg')
      }
    }
  },
  props: {
    groups: Array,
    edit: Boolean,
    loading: {
      type: Boolean,
      default: true
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";
@import "../../styles/table-layout.scss";

</style>
